import { cn } from "@helpers/utils";
import { useBaseCollapseContext } from "./context";
import { BaseCollapseHeaderProps } from "./types";

/**
 * BaseCollapse.Header - Modular header component for BaseCollapse
 * Must be used within BaseCollapse when using the composable API.
 */
export const BaseCollapseHeader = ({
    children,
    className,
    toggleOnClick = true,
}: BaseCollapseHeaderProps) => {
    const { isOpen, setIsOpen } = useBaseCollapseContext();

    const handleClick = () => {
        if (toggleOnClick) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div
            className={cn("p-[16px] select-none", className)}
            onClick={toggleOnClick ? handleClick : undefined}
            style={toggleOnClick ? { cursor: "pointer" } : undefined}
        >
            {children}
        </div>
    );
};


